<script>
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import meta from './data/meta.json';
    import pkg from '../package.json';
    import { onMount } from 'svelte';
    import manageParams from './utils/manageParams.js';
    import generateCopy from './utils/generateCopy.js';
    
    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);  
    let containerElement = $state();
    let manifestData = $state(null);
    let loadedData = $state(null);

    

    // $inspect(availableForecasts);
    
    // Get forecast from query params (defaults to D1)
    const params = manageParams();
    const forecast = params.forecast;
    
    const manifestUrl = 'https://ix.cnn.io/data/precipitation/manifest.json';
    
    function handlePymResize(newWidth) {
      width = newWidth;
    }
    
    function sendHeight() {
      if (pymChild) {
        pymChild.sendHeight();
      }
    }
    
    // Send map changes to parent window
    function handleMapChange(mapState) {
      if (pymChild) {
        pymChild.sendMessage('mapStateChange', JSON.stringify(mapState));
      }
    }
    
    
    // Fetch manifest data
    fetch(manifestUrl)
      .then(response => response.json())
      .then(data => {
        manifestData = data;
      })
      .catch(error => {
        console.error('Error fetching manifest:', error);
      });
    
    // Construct data URL based on manifest and forecast
    const constructDataUrl = (forecast) => {
      if (!manifestData) return null;
      const availableForecasts = Object.keys(manifestData['forecasts']);
      if (availableForecasts.includes(forecast)) {
        return manifestData['forecasts'][forecast].PROD_URL;
      } else {
        return manifestData['forecasts']['7day'].PROD_URL;
      }
    }
    let dataUrl = $derived(constructDataUrl(forecast));

    // $inspect(dataUrl);
    
    
    // Fetch forecast data when dataUrl changes
    $effect(() => {
      if (dataUrl) {
        fetch(dataUrl)
          .then(response => response.json())
          .then(data => {
            loadedData = data;
          })
          .catch(error => {
            console.error('Error fetching forecast data:', error);
          });
      }
    });

    const copy = $derived(generateCopy(forecast, manifestData));
    
    // REACT TO HEIGHT CHANGES using $effect
    $effect(() => {
      if (pymChild && height > 0) {
        sendHeight();
      }
    });

    $effect(() => {
      if (manifestData) {
        document.querySelector('h1').innerHTML = copy.headline;
        document.querySelector('h2').innerHTML = copy.subhed;
      }
    })
    

    onMount(() => {
      pymChild = new Child({ 
        renderCallback: handlePymResize, 
        id: pkg.name 
      });

      // Add app class to meta container if app param is true
      if (params.app === 'true') {
        document.querySelector('#meta')?.classList.add('app');
      }

      // hed
      // document.querySelector('h1').innerHTML = copy.headline;

      // dek
      // document.querySelector('h2').innerHTML = copy.subhed;
      
      // if (import.meta.env.DEV) {
      //   Object.keys(meta).forEach((id) => {
      //     const node = document.querySelector(`.${id}`);
      //     if (node) {
      //       node.innerHTML = meta[id];
      //     }
      //   });
      // }
      
      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }
      
    //   // onDestroy equivalent - cleanup function
      return () => {
        if (pymChild) {
          pymChild.remove();
        }
      };
    });
  </script>
  
  <!-- BIND HEIGHT HERE -->
  <div bind:this={containerElement} bind:clientHeight={height} class="app-container" class:app={params.app === 'true'}>
    <Graphic {width} {forecast} {manifestData} {loadedData} {copy} {params} onMapChange={handleMapChange} />
  </div>
  
  <style>
    .app-container {
      width: 100%;
    }
  </style>